const reports = {
	title: "Reports",
	select_report: "Select Report",
	filter_period: "Select Period",
	from_date: "From Date",
	to_date: "To Date",
	export_to_excel: "Export to Excel",
	rpt_course_overview: "Course overview",
	rpt_student_course_overview: "Student certification overview",
	rpt_billing: "Billing report",
	rpt_detailed_enrolment: "Detailed enrollment report",
	run_report: "Run Report",
	filter: "Filter",
	instructor: "Instructor",
	first_name: "First Name",
	last_name: "Last Name",
	course_name: "Course Name",
	course_type: "Course Type",
	course_template: "Course Template",
	enrolled_on: "Enrolled on",
	address: "Address",
	week: "Week",
	start_date: "Start Date",
	end_date: "End Date",
	qty_of_seats: "qty of seats",
	qty_enrolled: "qty enrolled",
	qty_attended: "qty attended",
	accomplishment: "Accomplishment",
	meet_up: "Meet up",
	company: "Company",
	zip: "Zip",
	city: "City",
	price: "Price",
	addons: "Addons",
	total_price: "Total price",
	attended: "Attended",
	filter_select_either_1: "Note: Company or at least one student or at least course type must be selected.",
};
export default reports;